import { Dot } from '@givebutter/primitives/dot';
import * as Tooltip from 'components/tooltip';

type StatusProps = {
    displayText: string;
    dotColor: string;
    tooltipText: string;
};

interface DataHygieneStatusProps {
    status: StatusProps;
}

const DataHygieneStatus = ({ status }: DataHygieneStatusProps) => {
    return (
        <Tooltip.Root>
            <Tooltip.Trigger>
                <div className="items-top flex gap-x-2 text-sm">
                    <div className="flex h-5 items-center">
                        <Dot className={`${status.dotColor ?? 'bg-orange-500'}`} />
                    </div>
                    <span className="text-left text-gray-600">{status.displayText}</span>
                </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse className="!max-w-56">
                    <p className="whitespace-normal">{status.tooltipText}</p>
                    <Tooltip.Arrow inverse />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};
export { DataHygieneStatus };
export type { StatusProps };
